import React, { useContext } from 'react'
import { TranslationContext } from 'contexts/TranslationContext'
import { DummyHeader } from '../components/DummyHeader'

export const HeaderContainer = ({ type }) => {
  const { t } = useContext(TranslationContext)
  return (
    <DummyHeader type={type} caption={t('TRANSITION_LIST_CAPTION_TRANSITION')} />
  )
}
